import React from 'react';
import { DVIInspectionFull } from '../../types/dvi';

export interface InspectionTabLabelProps {
  inspection: DVIInspectionFull | null;
}

export const InspectionTabLabel: React.FC<InspectionTabLabelProps> = ({ inspection }) => {
  let badge: React.ReactNode = null;
  if (inspection) {
    if (inspection.status === 'draft') {
      const done = inspection.items.filter(i => i.status !== 'pending').length;
      const total = inspection.items.length;
      badge = <span style={{
        marginLeft: 6, background: '#888', color: 'white',
        padding: '2px 6px', borderRadius: 10, fontSize: 11,
      }}>{done}/{total}</span>;
    } else if (inspection.status === 'completed') {
      const hasFail = inspection.items.some(i => i.status === 'fail');
      const hasAttn = inspection.items.some(i => i.status === 'attention');
      const color = hasFail ? '#ef4444' : (hasAttn ? '#facc15' : '#22c55e');
      badge = <span style={{
        marginLeft: 6, background: color, color: 'white',
        padding: '2px 8px', borderRadius: 10, fontSize: 11,
      }}>✓</span>;
    }
  }
  return <span>Inspection{badge}</span>;
};

export default InspectionTabLabel;
